<div class="mc-vertical-split-dialog">
  <div matDialogTitle class="mc-status-incident-dialog-header">
    <img class="mc-status-incident-dialog-header-icon" src="assets/images/status-incident/logo.svg" alt="Status">
    <button mat-icon-button color="secondary-invert" class="mc-vertical-split-dialog-close-button" tabindex="-1" [matDialogClose]="false">
      <mat-icon [fontSet]="'project-titan'" [fontIcon]="'icon-close'"></mat-icon>
    </button>
  </div>

  <mat-dialog-content class="mc-status-incident-dialog-content">
    <h3 class="mc-status-incident-dialog-title">{{ title }}</h3>
    <div class="mc-status-incident-dialog-body">
      <div class="mc-status-incident-dialog-update mc-border-divider" *ngFor="let update of sortedUpdates">
        <div class="mc-status-incident-dialog-update-header">
          <span class="mc-status-incident-dialog-update-status">{{ StatusIncidentStatus[update.Status] | mcStartCase }}</span>
          <span class="mc-status-incident-dialog-update-time mc-text-muted" *ngIf="update.CreatedOn">{{ update.CreatedOn | date:'MMM dd, yyyy h:mm a' }}</span>
        </div>
        <div class="mc-status-incident-dialog-update-message">{{ update.Body }}</div>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="mc-status-incident-dialog-actions">
    <a *ngIf="apiService.statusPageUri" [href]="apiService.statusPageUri" target="_blank">View Flare Online Status</a>
    <button mat-raised-button color="primary" [matDialogClose]="false">Close</button>
  </mat-dialog-actions>
</div>
